export const PARAGRAPH_BIG_SLIDER = () => `
   mainstageRelated {
      title
      author
      publishedOn
      category {
         label
      }
      featuredImage {
         mainstagse_1280x460
      }
   }`;

export default PARAGRAPH_BIG_SLIDER;
